import React from "react";
import { intl } from "dmsbasereact";
import { DmsAutocomplete } from "../DmsAutoComplete/DmsAutoComplete";
import { getRgIssuingAgencyOptions } from "../../constants/RgIssuingAgencies";

const DmsSelectRGIssuingAgency = ({ value, onChange, name, label, ...props }) => {
    return (
        <DmsAutocomplete
            name={name || "rg_issuing_agency"}
            label={label || intl.get("IssuingAgency").d("Issuing Agency")}
            options={getRgIssuingAgencyOptions()}
            value={value}
            onChange={onChange}
            {...props}
        />
    );
};

export default DmsSelectRGIssuingAgency;
